import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IConfirmReservationModalProps {
    visible: boolean;
    bodyText: string;
    onConfirm: () => void;
}

export const ConfirmReservationModal = observer(({ visible, bodyText, onConfirm }: IConfirmReservationModalProps) => {

    return (
        <Modal centered show={visible}>
            <Modal.Body>
                <br></br>
                <p>{bodyText}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary btn-customer" className={classNames('confirm', 'text-uppercase')} onClick={onConfirm}>Ok</Button>
            </Modal.Footer>
        </Modal>
    )
});
